module.exports = __webpack_public_path__ + "static/media/icon_prev.253f3213.svg";